import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { load, update } from "actions/userProfileActions";
import { connect } from "react-redux";
import EditUserProfileForm from "./editUserProfilePP";
import moment from "moment";
import * as R from "ramda";
import { loadDependantFields } from "actions/dependantActions";
import { Button, Loader } from "cxa-components";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";
import Dependants from "./Dependants";
import LifeStage from "./LifeStage";
import { renderAsHTML } from "../../utils";
import StandardMoney from "../common/StandardMoney";

const renderOutput = ({ id, value }) => <div id={id}>{!R.isEmpty(value) ? value : "-"}</div>;

renderOutput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.any,
};

const formatValue = (value, field, intl) => {
  if (!value || !field) {
    return "";
  }
  switch (field.type) {
    case "Date":
      return moment(value).format();

    case "Decimal":
      return <StandardMoney value={value} />;
    case "Boolean":
      return value === "True"
        ? intl.formatMessage({ id: "Yes", defaultMessage: "Yes" })
        : intl.formatMessage({ id: "No", defaultMessage: "No" });
    case "String":
      return renderAsHTML("span", intl.formatMessage({ id: value, defaultMessage: value }));
    default: {
      return intl.formatMessage({ id: value, defaultMessage: value });
    }
  }
};

const getImageUrl = (lifeStage, data) => {
  switch (lifeStage) {
    case "Single": {
      const gender = data["Gender"];

      if (gender === "Male") {
        return "/assets/images/common/SingleMale.png";
      }

      return "/assets/images/common/SingleFemale.png";
    }

    case "Couple":
      return "/assets/images/common/couple.png";

    case "YoungFamily":
      return "/assets/images/common/YoungFamily.png";

    case "MatureFamily":
      return "/assets/images/common/mature_family.png";

    case "PreRetirement":
      return "/assets/images/common/near_retirement.png";

    case "UNKNOWN":
      return "";

    default:
      return "";
  }
};

const UserProfileContainerPP = props => {
  useEffect(() => {
    props.load();
    props.loadDependantFields();
  }, []);

  const showEditPage = () => {
    props.history.push("/userProfile/edit");
  };

  const cancelEdit = () => {
    props.history.push("/userProfile");
  };

  const submitEmployee = (values, employeeKey) => {
    props.update(values, employeeKey);
    cancelEdit();
  };

  const { employee, lifeStage, myProfileNote, shouldDisplayDependant } = props.user;

  const { error, isCreationAllowed, fetching, intl } = props;

  const profileNoteForDisplay = intl.formatMessage({
    id: "noteContentProfile",
    defaultMessage: myProfileNote,
  });

  if (fetching) {
    return <Loader />;
  }

  if (!employee) {
    return null;
  }

  const dependantListDTO = R.propOr({}, "dependantListDTO")(props.user);
  const initialValues = employee.data;

  let isEmployeeEditable = false;
  employee.fields.forEach(field => {
    if (!field.disabled) {
      isEmployeeEditable = true;
    }
  });

  const translateMessage = messageValue => {
    return intl.formatMessage({ id: messageValue, defaultMessage: messageValue });
  };

  const pathName = window.location.pathname;
  const isEditPage = pathName === "/userProfile/edit";

  const employeeDataReadOnly = (
    <div>
      <article className="card">
        <section className="grid_user_profile">
          {employee.fields.map(field => {
            let value = formatValue(employee.data[field.id], field, intl);
            if (typeof value === "string") {
              value = renderAsHTML("span", value);
            }

            return (
              <div key={field.id}>
                <p className="profile-displayName">{translateMessage(field.displayName)}</p>
                <p className="profile-description">{value}</p>
              </div>
            );
          })}
        </section>
      </article>
      {isEmployeeEditable && (
        <Button primary type="button" onClick={showEditPage}>
          {intl.formatMessage(messages.editDescription)}
        </Button>
      )}
    </div>
  );

  const employeeDataEditable = (
    <EditUserProfileForm
      onSubmit={submitEmployee}
      fields={employee.fields}
      initialValues={initialValues}
      cancel={cancelEdit}
      error={error}
      employeeKey={employee.employeeKey}
      {...props}
    />
  );
  return (
    <div>
      <section>
        <h2 className="form-heading">{intl.formatMessage(messages.myProfileDescription)}</h2>

        <div>{isEditPage ? employeeDataEditable : employeeDataReadOnly}</div>
      </section>
      {lifeStage && lifeStage.display && (
        <LifeStage
          intl={intl}
          lifeStage={lifeStage}
          getImageUrl={getImageUrl}
          employee={employee}
        />
      )}
      {shouldDisplayDependant && (
        <Dependants
          intl={intl}
          dependantListDTO={dependantListDTO}
          isCreationAllowed={isCreationAllowed}
          profileNoteForDisplay={profileNoteForDisplay}
          formatValue={formatValue}
        />
      )}
    </div>
  );
};
UserProfileContainerPP.propTypes = {
  load: PropTypes.func,
  error: PropTypes.object,
  user: PropTypes.object,
  update: PropTypes.func,
  loadDependantFields: PropTypes.func,
  isCreationAllowed: PropTypes.bool,
  intl: intlShape.isRequired,
  fetching: PropTypes.bool,
  history: PropTypes.object,
};

const mapStateToProps = ({
  userProfile: { user, fetching, fetched, error, isCreationAllowed },
}) => ({
  user,
  fetching,
  fetched,
  error,
  isCreationAllowed,
});

const mapDispatchToProps = { load, update, loadDependantFields };

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(UserProfileContainerPP));



// WEBPACK FOOTER //
// ./components/employee/UserProfileContainerPP.js